module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAwUlEQVQ4jaVTbQ6FMAgrxnuv3Iyb9f1g6nTDmDwSEsz4aKGaJFRmZgIASVblbNWDu4lkj72eImlyMkMAiojTV7llMUmRPApFUve8/F4W5wvO4meDMd4PvgDQGgAIQLkzuLtaa1dCTtUw7UKQK5oRjN6vcDS0G4KIgFmNBkBSGG5yaxIRSwrTJUl0iDhpfKWwS7JUHJGLfEfwtA05xiQZCbiPO5ltojApa6DUYb/qYCnlowkGKX9SYtWkWqAkmP78nX8w/aAz0SwsYAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/SND.png
// module id = 100
// module chunks = 0